import { Image, Pressable, StyleSheet } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { View } from '@/components/Themed';
import { CustomDivider } from "@/components/CustomDivider";
import {
  Anchor,
  AppBar,
  Button,
  Checkbox,
  Desktop,
  FAB,
  Fieldset,
  Hourglass,
  Label,
  List,
  NumberInput,
  Panel,
  Progress,
  Radio,
  SelectBox,
  Slider,
  Snackbar,
  Tabs,
  TextInput,
  Title,
  Toolbar,
  Window
} from 'react95-native-rabbl';
import Head from 'expo-router/head';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtils from '@/utilities/AppUtils';
import { AppText } from '@/components/AppText';
import { AppText95 } from '@/components/AppText95';
import { useRouter } from 'expo-router';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
});

const icons = [
  {
    label: 'Notepad',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAFVBMVEUAAAAAAAD///8A///AwMAAgICAgICShRTRAAAAAXRSTlMAQObYZgAAAKxJREFUKM+FksEJwzAMReMN7FTNvaYLBNQFUrV3HzqAIXj/ERpLcuSGQB86Pb4+MskwnOF8kGliDDcZNW5GkElexFN5QWYBqDxUXFoiEQuHGCqITViFCMC5BmCrEGEVZc1SoSS650MFC7tikpXuiqUm+goRe8VUeKV7CMWa6CpEXD9KKrLiggK0cIJfQ4yJrV9YfxPxuBL/rURLjFEhFY6Utwor8e1rt3NP/oQvTyZR+XxB8B0AAAAASUVORK5CYII=',
  },
  {
    label: 'PowerOff',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAGFBMVEUAAACAgID////AwMAAAAD/AAAAAIAAAP/DlrJZAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAHdElNRQflAQwXHQ1lXxPNAAAAxUlEQVQoz32RTQ6CMBBGawJ7B/AAwgmaoXsNDWsTHA9gQC5gPL8z0D8x4Qts3rxOp61SawCOKs2hbn4AQIOVjWWozw1UYC++XiBaewWoHCh0iRIdAGqQlBG47IK2iyCnYQWGbishwtbaDonckhMNAgzdfQ9RRAhNDSssDHEXVuSPgKv8pXMQiZQAQzLMHtgu+Wu63VaqmAz2FEGU0YFJBFH84Viw6fFzeiy3rid/Qdns4h9K9Z8l7/CWWf/ijEFgwk3dy34B82lC6z0gIAEAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjEtMDEtMTJUMjM6Mjk6MTMrMDA6MDDJz0whAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIxLTAxLTEyVDIzOjI5OjEzKzAwOjAwuJL0nQAAAABJRU5ErkJggg==',
  },
  {
    label: 'Tree',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAGFBMVEUAAAAAgAD///8A/wD//wAAAACAgACAAADkuDBqAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAHdElNRQflAQwXHQ1lXxPNAAAA20lEQVQoz62QUY7DIAxEnY9mf+u6HAD1BGibe4AqJyegnIA9/47xtkr2uwMSmvGzISEy8RC9NHGMKSJJ7vlylSuL6TzqN4G3evKuC3OEEfOWTPHOwmML8jONA+Jv8av4Pk4ZQxIvNiLZEm9S4puXHQgBr7IJ4qEUpSkZYZdilZDxUB+BASGEguBkxbGXgg5I62NMgLUOaFOFX0JQ9zR30rWovjxRy19dqen7D819bnnubwDIWvMOAPLT1j1A9KzbHgDSNB+DegRA5H9BzR8g+jF4btsBOeHb/x7yCxoPMLnchctIAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTAxLTEyVDIzOjI5OjEzKzAwOjAwyc9MIQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wMS0xMlQyMzoyOToxMyswMDowMLiS9J0AAAAASUVORK5CYII=',
  },
  {
    label: 'Unmute',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAFVBMVEUAAACAgAAAAACAgIDAwMD//////wAkoAZpAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAHdElNRQflAQwXHQ1lXxPNAAAAy0lEQVQoz42RSxKDIAxAg54AK64r1j1T2gNUKweoDRco9P5HKKLycdUsmMnjTSAJwL9RnZezDDkZxiUXAdSXt0hz8uxRJDnUnzvOSUWiXlMGajvsQKyC3kApN8F2E6IA6e8p/Wr0oNxefFhcwVqQaYaIXEaAC+jmPhqN1joFlln3yrj8XboAphqllAebYWpjTCcj8Abn0w4Ipd4IADh3SncLP3XROiPpBaCg6pp1Cy3N5+GUKp8YtKd8pk45TB3aw16gqA6bA37YbYwflrYzo8mrW7wAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjEtMDEtMTJUMjM6Mjk6MTMrMDA6MDDJz0whAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIxLTAxLTEyVDIzOjI5OjEzKzAwOjAwuJL0nQAAAABJRU5ErkJggg==',
  },
  {
    label: 'Keys',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAFVBMVEUAAAAAAACAgID////AwMCAgAD//wA+bLkQAAAAAXRSTlMAQObYZgAAAPFJREFUKM9VkEFywyAMRcGTAwDjsg4SYe+EC1Cr3nvR7skk3P8Ixdiy47+S3jz9YRCiRmslPiOvwn3u4OAKcDjdY/COaN4Jku5B2/fMQkxgspHlR7Ew+JBVKq+ZQcKQLykfIOpQwFq73SCN36GUnF9vBhErsHbajC6OaBeBjapgKmWa2KgKpnpTdkMgklmI2996j8kAhOfXcUOD1nZXkCCO5GRhBckj3ZUIrEjvTYQFsNJX4JXofjeli/WkAuHsqrSOBXBL7dC+gdvfU68dqm+g08WtHa10GdtX76U1rometg5On0x/AlLJeAJNOu9V4ukf9rY2A1/ZhUcAAAAASUVORK5CYII=',
  },
  {
    label: 'Defrag',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAACAAICAgID//////wAAAAD/AP+AAACAgADAwMD/AAAAgAAA/wAAAIAAAP8AgIAA//8CrCWZAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAHdElNRQflAQ0AAgEAZoPoAAAA8ElEQVQ4y33SWwKEIAgFUDXRisr2v9oBfOI4Q3/eE2JpzLqsnRacczrftHCb9yOB0EWMkcC+K3J0EcN5xui816QLaiDEZ7LDLCKnnTQg4rACMokgogES9BTA5AsYySs4B4B4FGE6QMQKELcqOsDtuhAzgEuJWBsIkS20KIBTIiBDKtEAE4RdfiOJo4oBkIAQApP8CVbA2kxgmuHuHYTAfMz7edoWRCyDJNUBEQIpC6i5G8Fzp/dNqYKXCxSgN3itAOAyGnCDVMA05F3A+wUAzkaWYCQ/QCcp/QAjoZu1Ao3w3bSwyCthsI4L+RdnMq98AAK4FL2Wak4JAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTAxLTEzVDAwOjAyOjAxKzAwOjAwwLomUgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wMS0xM1QwMDowMjowMSswMDowMLHnnu4AAAAASUVORK5CYII=',
  },
  {
    label: 'MediaCD',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAGFBMVEUAAAAAAACAgID//wDAwMD///8A//8A/wDOM1s/AAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAHdElNRQflAQ0AAgEAZoPoAAAA7UlEQVQoz2XRzW7DIAwHcJcngKjteVhe+wBMyjmJyc6bsgdoG3HfFK2vPxOgHyyn8MvfDrIBAAxUj9E11GJq0Zsa4B+ARsRyjHnVuDfGlwQ7oxXuBbhLhVujj78rcJd/2nyb/SWC16kH7TJMH6nLYZvAe7ueVTAJps9+rVF8MlcB74lWIOb5/QdJAn2XYWRrmi8ishn4rMFif0+wdLNUrha/PIGUEtaJSZryQ+LV93i4gZLAxMM4C6SbSoDZLaEAoAR4WMKcBwIxwO46hgJKAjwIzGX48QauXcKpDF6JDO1i79sRce3Ttjay3/T2B3yQPfBCfRXXAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTAxLTEzVDAwOjAyOjAxKzAwOjAwwLomUgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wMS0xM1QwMDowMjowMSswMDowMLHnnu4AAAAASUVORK5CYII=',
  },
  {
    label: 'Bookmark',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAJ1BMVEUAAACAgID///8AAADAwMAAgIAAgAAA/wCAAID/AP+AgAD//wAA///5GE4vAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAHdElNRQflAQwXHQ1lXxPNAAAAq0lEQVQoz2NgIAcIggADI4gUAPOFlIAAShqA+GCmMIhQEjE0YBAVEnIBAmEVIOEkkpYMEgCrcAKrKC9GUwERQFJhbIymwtQATUVHM5qKmZPRVCAJQFQgGQpRgWQoRMWqxWgqdm+Gq1BCEkCyFmIokrUYhoYGo6k4cxjNUAwBsKHgUBdWBJFgQ41BwERYBEyDBEJBINjYGEyHGjAYQ2RCQyEMA2jsMQNNIxYAAJmCSHaZSKbTAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTAxLTEyVDIzOjI5OjEzKzAwOjAwyc9MIQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wMS0xMlQyMzoyOToxMyswMDowMLiS9J0AAAAASUVORK5CYII=',
  },
  {
    label: 'Brush',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAALVBMVEUAAAAAAADAwMD//////wCAgAD/AP+AAIAA/wAAgAAAAP+AgID/AACAAAAAAIDFDtfpAAAAAXRSTlMAQObYZgAAATRJREFUKM9tkj1OxDAQhdc3yMTQbKqFiQQICggnsAQICqQUuYLTI6ScIe2KIinTukDiCtROg7aEBlFR5AzMjJ3dLZjCkl8+v/nLYvFPKABI9u9pURSrPUUXiHhU7oArw3ETEDo1orUWMSBAgjG31tZmFtSxEDXm/EZdisUdKU9ioom4phyNrZ/FBCAmaRrDJooK1HjSoQSZaM5q2raVSkxJllxG13UvAdHie0/Emr7n1WoQ4bTremkGltkbC6bv19KLGrI8tBJzLJOUe6ZWjH8nAoZFyrUQce5HQspESS2KAD+yCaQyFZK995utExOfAZnndoAXftzgmYsEp/n6MA/OvUZCBoKO4gexkuL5MQvfJgxWkF/nJrIIk86IeJwmOquwHHUYi6hgu+yKo4x33hbA/Af8AeB3ZmU7WGsvAAAAAElFTkSuQmCC',
  },
  {
    label: 'Earth',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgAgMAAAAOFJJnAAAADFBMVEUAAAAAAAAAAP8A/wB4yMwVAAAAAXRSTlMAQObYZgAAAKtJREFUGNNN0LERgzAMBVDRJBOkockqDBGW8BKswBBp+FxwkzZ4BdYIRSoq50D5skkuavzO9+WzJCJS15LqNOBiZ9HMvquIo+KNiTgbFqLRl2JlRFU3hEoOIWHaMbRSEhG4f7EYQkS/iPM6Equ4PmLMYA/4osMG1oPwhhuRrn7oDD4YSkIV1x3zHw4ZrQH8UCtFBuex/thxCkszKynNLOdx6J9VWgLyEva1fACDe5MuQgDwPAAAAABJRU5ErkJggg==',
  },
  {
    label: 'Dial',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAFVBMVEUAAACAgID///8AAADAwMCAAAD/AADqeraFAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAHdElNRQflAQwXHQ1lXxPNAAAAqElEQVQoz5WOMQ6DMAxFLUXda3yCGLrTwAmC2CtV5QJVuf8RmmCCTaQOtX6Wp+cfA5aBfRpuJQdAkhyASPLToGGQ/FuKVWnTVaWB/R3xakoDUxcmU0rsw9T15lJV9m9VKZc2zLyBXNr6wAqyHwkV5NLRp1OMgRSZC5DSUYGMixUAUeaHKhuZ36q4IW0tH7OUtm7r+jTAxWU9GfA6CwC1AJdKSDt9BVx6XzBwJ8Kxeb3/AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTAxLTEyVDIzOjI5OjEzKzAwOjAwyc9MIQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wMS0xMlQyMzoyOToxMyswMDowMLiS9J0AAAAASUVORK5CYII=',
  },
  {
    label: 'TimeDate',
    uri:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAHlBMVEUAAACAgIAAAAD////AwMAAAP+AAAD/AAAAAICAgABbUNNuAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAHdElNRQflAQwXHQ1lXxPNAAAA7klEQVQoz22RQY7CMAxFzSy6JkzFunVGPQCmVdlSNBeocoKRkn0W+Aqz58LYUZtGgBdx8vLt7yiwMxr7tJoGAHakcf1O6SCgLUGNCbgEekn1oRGgO3sl5+YCIJLrV7CU0BtwL2BrugAR5Kbzq8ucXLYexaSfASIO3v9JyoohMN9toQjceY6bYmAk8mxz0xDpNOmagZbTsAJzFPGoha1RgPWvXI0XEf7cbgrMMZ5pfJANrTEKsIsnGv+nKcho2MCXAKKHdE1A/gEqthd1Yf2mFKstZBDpbGWwDCrudPRcIRL28rjtDJU8PxYCEG9cz09/GlpfiqrQXAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wMS0xMlQyMzoyOToxMyswMDowMMnPTCEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMDEtMTJUMjM6Mjk6MTMrMDA6MDC4kvSdAAAAAElFTkSuQmCC',
  },
];

export default function TestScreen() {
  const dispatch = useDispatch();
  const router = useRouter();

  return (
    <BasicScrollView center={true}>
      <Meta title={"Test"} />
      <AppText>Hello World</AppText>
      <AppText95 bold>Hello World</AppText95>
      <AppText95 secondary>Hello World</AppText95>
      <AppText95 disabled>Hello World</AppText95>
      <Title>Hello World</Title>
      <Anchor>Hello World</Anchor>
      <Anchor underline>Hello World</Anchor>
      <Button onPress={() => {}}>Hello World</Button>
      <Button onPress={() => { AppUtils.showInformationalToast("Test toast"); }}>Toast</Button>
      <Button
        onPress={() => {
          AppUtils.showPressableToast(
            "Test toast",
            () => {
              router.navigate('/');
            },
            "Custom button text",
          );
        }}
      >Pressable Toast</Button>
      <Button onPress={() => { AppUtils.showErrorToast("Error toast text", () => { console.log("Retried") }); }}>Error toast</Button>
      <Button variant='raised' onPress={() => {}}>Hello World</Button>
      <Button variant='menu' onPress={() => {}}>Hello World</Button>
      <Button variant='flat' onPress={() => {}}>Hello World</Button>
      <Button primary onPress={() => {}}>Hello World</Button>
      <Button onPress={() => {}}>Hello World</Button>
      <Button active onPress={() => {}}>Hello World</Button>
      <Button disabled onPress={() => {}}>Hello World</Button>
      <Button square onPress={() => {}}>OK</Button>
      <Button onPress={() => {}}>OK</Button>
      <Window style={{ width: "80%" }} title='Hello World'>
        <AppText>Hello World</AppText>
      </Window>
      <CustomDivider fullWidth={true} />
      <FAB />
      <Panel>
        <Fieldset label='Name:'>
          <AppText>Some text here</AppText>
        </Fieldset>
      </Panel>
      <AppBar>
        <AppBar.BackAction onPress={() => {}} />
        <AppBar.Content title='Timeline' subtitle='sport' />
      </AppBar>
      <Desktop>
        <View style={{ backgroundColor: 'teal', flex: 1, }}>
          <AppText>Hello World</AppText>
        </View>
      </Desktop>
      <Label>Hello World</Label>
      <Label elevation={10}>Hello World</Label>
      <Hourglass />
      <Panel style={{ width: "80%" }}>
        <Fieldset label='Default' style={{ gap: 20 }}>
          <NumberInput value={1} />
          <NumberInput
            disabled
            value={20}
            inputWidth={80}
          />
          <NumberInput
            variant='flat'
            min={0}
            max={3}
            defaultValue={1.5}
            step={0.3}
            inputWidth={80}
          />
          <Progress percent={50} background='canvas' />
          <Progress variant='tile' percent={50} />

          <Radio
            status={'checked'}
            onPress={() => {}}
            label='Apple'
          />
          <Radio
            status={'unchecked'}
            onPress={() => {}}
            label='Orange'
          />

          <Checkbox
            status={'unchecked'}
            onPress={() => {}}
            label='Orange'
          />
          <Checkbox
            status={'checked'}
            onPress={() => {}}
            label='Apple'
          />

          <SelectBox
            options={[
              'apple',
              'orange',
              'banana',
              'pear',
              'watermelon',
              'kiwi',
              'raspberry',
              'pineapple',
              'grapefruit',
            ].map(option => ({
              label: option,
              value: option,
            }))}
            value={'watermelon'}
            onChange={newValue => {}}
          />

          <Slider
            step={2}
            onChange={() => {}}
            onChangeCommitted={() => {}}
            value={1}
          />

          <Snackbar
            visible={false}
            onDismiss={() => {}}
            action={{
              label: 'Undo',
              onPress: () => {
                // Do something
              },
            }}
            duration={Snackbar.DURATION_MEDIUM}
            style={{
              position: 'absolute',
              flex: 1,
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          >
            Hi! I am Clippy, your office assistant.
          </Snackbar>

          <View style={[{ paddingVertical: 8, backgroundColor: 'transparent' }]}>
            <AppText style={{ marginBottom: 8 }}>Default:</AppText>
            <Tabs value={0} onChange={() => {}}>
              <Tabs.Tab value={0}>Shoes</Tabs.Tab>
              <Tabs.Tab value={1}>Accesories</Tabs.Tab>
              <Tabs.Tab value={2}>Clothing</Tabs.Tab>
            </Tabs>
            <Tabs.Body style={[{ height: 200 }]}>
              <AppText>{0}</AppText>
            </Tabs.Body>
          </View>

          <View style={[{ paddingVertical: 8, backgroundColor: 'transparent' }]}>
            <AppText style={{ marginBottom: 8 }}>Stretched:</AppText>

            <Tabs stretch value={1} onChange={() => {}}>
              <Tabs.Tab value={0}>Shoes</Tabs.Tab>
              <Tabs.Tab value={1}>A</Tabs.Tab>
              <Tabs.Tab value={2}>Clothing</Tabs.Tab>
            </Tabs>
            <Tabs.Body style={[{ height: 200 }]}>
              <AppText>{1}</AppText>
            </Tabs.Body>
          </View>

          <TextInput value='Test' disabled={false} onChange={() => {}} />
          <TextInput multiline defaultValue={'Placeholder'} />

          <View style={{ backgroundColor: 'teal', flex: 1 }}>
            <AppBar style={{ padding: 2 }}>
              <AppBar.Content title='Office' subtitle='tools' />
              <View style={{ backgroundColor: 'transparent', flexDirection: 'row', alignItems: 'center', height: 40, minWidth: 200 }}>
                <View style={{ backgroundColor: 'transparent', flex: 1, paddingHorizontal: 4 }}>
                  <Toolbar>
                    {icons.map(icon => (
                      <Pressable
                        key={icon.label}
                        onPress={() => {}}
                      >
                        <Image
                          source={{ uri: icon.uri }}
                          style={{
                            marginHorizontal: 8,
                            width: 32,
                            height: 32,
                          }}
                          key={icon.label}
                        />
                      </Pressable>
                    ))}
                  </Toolbar>
                </View>
              </View>
            </AppBar>
          </View>
          <List.Accordion
            title='Uncontrolled'
            subtitle='subtitle'
            defaultExpanded
          >
            <List.Section title='Groceries'>
              <List.Item title='Vegetables' />
              <List.Item title='Bread' />
              <List.Item title='Meat' />
            </List.Section>
            <List.Divider />
            <List.Section title='Other'>
              <List.Item title='Accesories' />
              <List.Item title='Electronics' />
              <List.Item title='Art' />
            </List.Section>
          </List.Accordion>
        </Fieldset>
      </Panel>
      <View style={{ padding: 50, backgroundColor: 'transparent' }} />
    </BasicScrollView>
  );
}
